import React, {
  useCallback,
  useState,
  useEffect,
  useMemo,
  useRef,
} from "react";
import useSelfpointEffect from "../common3/hooks/useSelfpointEffect";
import filterString from "../common3/filterString";
import DotLoader from "../common3/Loaders/DotLoader";
import PaginationBar from "./PaginationBar";
import get from "lodash/get";
import produce from "immer";
import { injectIntl } from "react-intl";
import { Card, InfoBar, CardsWrapper, CardLink } from "./styled";

const EffectCard = injectIntl((props) => {
  const {
    extra = {},
    dispatchEvent,
    // formData,
    document,
    htmlTemplates = {},
    id,
    save,
    value,
    disabled,
    intl,
  } = props;
  const {
    // label,
    template = "",
    pageSize = 100000,
    lineKey,
    enableSelection = false,
    watchFormFields = [],
    templateId,
    cardWidth = "100%",
    showHitCount = true,
    noHitsLabel = "EffectCard.NotHits",
    noResultsLabel = "EffectCard.NoResultsLabel",
    enablePagination,
    isLink,
    to,
    selectedValueLabel = "EffectCard.SelectedLabel",
  } = extra;
  const [page, setPage] = useState(1);
  const [select, setSelect] = useState(value);

  let watchArray = useMemo(() => {
    // special case for builder
    if (!document) {
      return [page, pageSize];
    }

    return watchFormFields.reduce(
      (acc, cur) => {
        acc.push(document[cur]);
        return acc;
      },
      [page, pageSize]
    );
  }, [page, pageSize, document, watchFormFields]);

  //eslint-disable-next-line
  const [loading, effect] = useSelfpointEffect({
    ...props,
    watchArray,
    context: { skip: +(page - 1) * pageSize, limit: +pageSize },
  });

  const onClick = useCallback(
    (line) => {
      if (enableSelection) {
        if (
          (select && select === line) ||
          (lineKey && select[lineKey] === line[lineKey])
        ) {
          dispatchEvent("onDeselect", line);
          setSelect(null);
        } else {
          if (line[lineKey]) {
            //dispatchEvent("onDeselection", select)
          }
          dispatchEvent("onSelect", line);
          setSelect(
            produce(() => {
              return line;
            })
          );
        }
      }
      dispatchEvent("onClick", line);
    },
    [dispatchEvent, select]
  );

  const mountRef = useRef();

  useEffect(() => {
    if (mountRef.current) {
      save({ key: id, value: select });
    } else {
      mountRef.current = true;
    }
  }, [select]);

  if (!effect) {
    return <DotLoader />;
  }

  let results = get(effect, "results", effect);
  const totalCount = get(effect, "totalCount", effect.length);

  const _template =
    templateId === "_custom"
      ? template
      : get(htmlTemplates, [templateId, "html"], "");

  // convert result to array in order to display single values
  if (!Array.isArray(results)) {
    results = [results];
  }

  return (
    <>
      {value && (
        <>
          <InfoBar>
            {selectedValueLabel
              ? intl.formatMessage({ id: selectedValueLabel })
              : ""}
          </InfoBar>
          {
            <CardsWrapper>
              <Card
                disabled={true}
                cardWidth={cardWidth}
                selected={true}
                onClick={() => {}}
                className="sp-effect-card w-100"
                dangerouslySetInnerHTML={{
                  __html: filterString(_template, props, value),
                }}
                enableSelection={enableSelection}
              />
            </CardsWrapper>
          }
        </>
      )}
      {!(disabled && enableSelection) && (
        <>
          {showHitCount && (
            <InfoBar>
              {noResultsLabel &&
                intl.formatMessage({ id: noResultsLabel }, { totalCount })}
            </InfoBar>
          )}
          {totalCount === 0 && (
            <div>{noHitsLabel && intl.formatMessage({ id: noHitsLabel })}</div>
          )}
          <CardsWrapper>
            {results &&
              Array.isArray(results) &&
              results.map((line, i) => {
                if (pageSize && i > pageSize) {
                  return null;
                }

                const selected =
                  get(line, [lineKey], false) ===
                  get(select, [lineKey], "_nomatch_");

                const _Card = (
                  <Card
                    cardWidth={cardWidth}
                    selected={selected}
                    onClick={() => onClick(line)}
                    className="sp-effect-card"
                    enableSelection={enableSelection}
                    dangerouslySetInnerHTML={{
                      __html: filterString(_template, props, {
                        ...line,
                        value: line,
                      }),
                    }}
                  />
                );

                return isLink ? (
                  <CardLink width={cardWidth} to={to} {...line}>
                    {_Card}
                  </CardLink>
                ) : (
                  _Card
                );
              })}
          </CardsWrapper>
          {totalCount !== 0 && enablePagination && (
            <PaginationBar
              totalCount={totalCount}
              page={page}
              setPage={setPage}
              pageSize={pageSize}
            />
          )}
        </>
      )}
    </>
  );
});

export default EffectCard;
